import React, { useEffect, useState } from 'react';

import { FormPessoa } from '../../components/FormPessoa';
import { ErrorRetrievingData } from '../../components/ErrorRetrievingData';
import MenuMain from '../../MenuMain';

import { AppFooter } from '../../AppFooter';

import api from '../../api/api';

export default function EditarPessoaPage(props) {

    const [pessoas, setPessoas] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [errorGettingPessoas, setErrorGettingPessoas] = useState(false)
    const [errorMessage, setErrorMessage] = useState('');
    const [idPessoas] = useState(props.match.params.id)

    const getPessoas = async (id) => {
        setIsLoading(true);

        try {
            const response = await api.get(`pessoa/${id}`)
            
            setPessoas({
                'id': response.data.id,
                'nome': response.data.nome,   
                'cpf': response.data.cpf,  
                'numero_instalacao': response.data.numero_instalacao, 
                'arquivo': response.data.arquivo,
                'rural': response.data.rural,     
                'endereco_ou_fazenda': response.data.endereco_ou_fazenda,  
                'bairro_ou_distrito': response.data.bairro_ou_distrito, 
                'campanhaMudas': response.data.campanhaMudas,    
            })

            setErrorGettingPessoas(false)
        }
        catch (error) {
            setErrorMessage(error.toString())
            setErrorGettingPessoas(true)
        }

        setIsLoading(false);
    }

    useEffect(() => {
        getPessoas(idPessoas)
    }, [])

    return (
        <>
            <MenuMain >
                {
                    errorGettingPessoas ?
                        <ErrorRetrievingData
                            errorMessage={errorMessage}
                            retrieveFunction={() => getPessoas(idPessoas)}
                            isLoading={isLoading}
                        />
                        :
                        <FormPessoa
                            defaultValues={pessoas}
                            isEditing={true}
                            isLoading={isLoading}
                        />
                }
            </MenuMain>
            <AppFooter />
        </>
    );
}
